import WithErrorHandling from "@/modules/common/components/wrappers/with-error-handling";

import {
  PropertyTrackTabOptions,
  Track,
} from "@/modules/property-tracks/types";

import PropertyActivityMobile from "@/modules/property-tracks/components/activity-tab/mobile";
import FullPageModal from "@/modules/common/components/ui-kit/full-page-modal/full-page-modal";
import PropertyOverview from "@/modules/property-tracks/components/overview-tab";
import LinkedTracksTabMobile from "@/modules/property-tracks/components/linked-tracks-tab/mobile";
import TenantsMobileTab from "@/modules/property-tracks/components/tenants-tab/mobile";
import SubpropertiesTabMobile from "@/modules/property-tracks/components/sub-properties-tab/mobile";
import InterestsMobileTab from "@/modules/property-tracks/components/interests-tab/mobile";
import DocumentsMobileTab from "@/modules/property-tracks/components/documents-tab/mobile";
import ActiveListingMobileTab from "@/modules/property-tracks/components/listing-tab/mobile";
import PropertyConstructionMobileTab from "@/modules/property-tracks/components/construction-tab/mobile";
import PageComponentsWrapper from "@/modules/common/components/wrappers/page-components-wrapper";
import DrawingProposalsMobileTab from "@/modules/property-tracks/components/drawing-proposals-tab/mobile";

function TabContentMobile({
  selectedTab,
  track,
  handleTabURLChange,
}: Readonly<{
  selectedTab: PropertyTrackTabOptions;
  track?: Track;
  handleTabURLChange?: (tab: PropertyTrackTabOptions | null) => void;
}>) {
  if (!track) {
    return null;
  }
  return (
    <>
      <PropertyActivityMobile
        track={track}
        open={selectedTab === "Activity"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
      />

      <FullPageModal
        isOpen={selectedTab === "Overview"}
        title="Overview"
        onClose={() => {
          handleTabURLChange?.(null);
        }}
      >
        <PropertyOverview track={track} />
      </FullPageModal>
      <DocumentsMobileTab
        open={selectedTab === "Documents"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
        track={track}
      />
      <PageComponentsWrapper
        page="property-details"
        component="property-construction-tab"
      >
        <PropertyConstructionMobileTab
          open={selectedTab === "Construction"}
          onClose={() => {
            handleTabURLChange?.(null);
          }}
          track={track}
        />
      </PageComponentsWrapper>
      <SubpropertiesTabMobile
        open={selectedTab === "SubProperties"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
        property={track.property}
      />
      <LinkedTracksTabMobile
        open={selectedTab === "LinkedTracks"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
        track={track}
      />
      <ActiveListingMobileTab
        open={selectedTab === "Listing"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
        track={track}
      />
      <TenantsMobileTab
        open={selectedTab === "Tenants"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
        track={track}
      />
      <InterestsMobileTab
        open={selectedTab === "Interests"}
        onClose={() => {
          handleTabURLChange?.(null);
        }}
        track={track}
      />
      <PageComponentsWrapper
        page="property-details"
        component="drawing-propsal-requests"
      >
        <DrawingProposalsMobileTab
          open={selectedTab === "DrawingProposals"}
          onClose={() => {
            handleTabURLChange?.(null);
          }}
          track={track}
        />
      </PageComponentsWrapper>
    </>
  );
}

const TabContentMobileWithError = WithErrorHandling(TabContentMobile);

export default TabContentMobileWithError;
